import React from "react";
import Grid from "@mui/material/Grid";
import PreAuthTopMenu from "../layouts/PreAuthTopMenu";
import { Container } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { pageRoutes } from "../constants";

export default function Main(props) {
  const { pathname } = useLocation();

  return (
    <>
      {pathname !== pageRoutes.REGISTER || pathname !== pageRoutes.LOGIN || pathname !== pageRoutes.PRIVACY && <PreAuthTopMenu />}
      <Container style={{ maxWidth: "100%", padding: 0 }}>
        <Outlet />
      </Container>
    </>
  );
}
